import { render } from "./Procedures.vue?vue&type=template&id=bb4bfcd4&scoped=true"
import script from "./Procedures.vue?vue&type=script&lang=js"
export * from "./Procedures.vue?vue&type=script&lang=js"

import "./Procedures.vue?vue&type=style&index=0&id=bb4bfcd4&scoped=true&lang=css"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4bfcd4"]])

export default __exports__